// extracted by mini-css-extract-plugin
export default {"PostedBy":"PostedBy_PostedBy__2RXHa","Logo":"PostedBy_Logo__9aCZQ","Text":"PostedBy_Text__Rmda7","Title":"PostedBy_Title__bybJf","User":"PostedBy_User__+2PwE"};